module.exports = __webpack_public_path__ + "assets/img/thumb-Amaze-Wholesale-1-Landing-Page.e486ea43.jpg";